/** The page that creates a record of a resource edited on its own page (`usesFormPage`). */
export const NEW_RECORD = 'new';

/** `preset`: values the new record starts with and keeps (a list's `fixed` values, e.g. a page of kind form). */
export function newRecordRoute(resourceKey: string, parentId?: string, preset?: Readonly<Record<string, string>>) {
  const query = new URLSearchParams();
  if (parentId) query.set('parent', parentId);
  for (const [key, value] of Object.entries(preset ?? {})) query.set(`preset.${key}`, value);
  const text = query.toString();
  return `/records/${resourceKey}/${NEW_RECORD}${text ? `?${text}` : ''}`;
}

/** The shared record page of a resource; children of children also carry their parent's id. */
export function detailRoute(resourceKey: string, id: string, parentId?: string) {
  return `/records/${resourceKey}/${id}${parentId ? `?parent=${parentId}` : ''}`;
}
